import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelessChangeUserModel
    //action
    , setPurposeOptions
    , setBusinessCaseOptions
    , setSubscriptionDetails
    , setNewUserDetails
    , setFormSubmitted
    , setFormLoading
    , setResetLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-change-user.settings';
import { requestDetailsActions } from '../../request-details.reducer'; 

export const changeUserModelAInitialState = wirelessChangeUserModel;

const defaultState = () => ({
    subscription: {}
    , newUser: {}
    , purposeOptions: []
    , businessCaseOptions: []
    , formSubmitted: false
    , isFormLoading: false
    , isResetLoading: false
});

const initialState = defaultState();

export const wirelessChangUserActions = {
    setLoadForm: (isLoad = false) => (dispatch, state) => {
        dispatch({
            type: setFormLoading,
            data: isLoad
        });
    },

    getListOfPurpose: () => (dispatch) => {
        fetchPurposeList(dispatch);
    },

    getBusinessCase: () => (dispatch) => {
        fetchBusinessCaseList(dispatch);
    },

    onLoadUpdateChangeUserRequest: (subscriptionList, circuitCodePropName) => (dispatch, state) => {
        const { requestData } = state().requestDetail;
        const { employeeList } = state().createRequest;

        dispatch(actions.reset('wirelessChangeUserFormA'));



        if (requestData.Circuit.CircuitCode) {
            getEmployeeDetails(dispatch, state, requestData.NewRequest.User.LastFirstName, employeeList)

            dispatch(actions.change("wirelessChangeUserFormA.circuitCode", requestData.Circuit.CircuitCode));
            dispatch(actions.change('wirelessChangeUserFormA.circuitId', requestData.Circuit.CircuitId ?? 0));
            dispatch(actions.change('wirelessChangeUserFormA.employeeEmail', requestData.NewRequest.User.LastFirstName));
            dispatch(actions.change('wirelessChangeUserFormA.employeeId', requestData.NewRequest.User.EmployeeId));
            dispatch(actions.change('wirelessChangeUserFormA.purposeOfUseId', requestData.BusinessJustification.PurposeOfUseId));
            dispatch(actions.change('wirelessChangeUserFormA.purposeOfUse', requestData.BusinessJustification.PurposeOfUse));
            dispatch(actions.change('wirelessChangeUserFormA.busJustiCodeDetailId', requestData.BusinessJustification.BusJustiCodeDetailId));
            dispatch(actions.change('wirelessChangeUserFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
            dispatch(actions.change('wirelessChangeUserFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));

            var subscription = subscriptionList.find(o => o[circuitCodePropName] === requestData.Circuit.CircuitCode);
            dispatch({ type: setSubscriptionDetails, data: subscription });
        }
        else {
            dispatch(actions.reset('wirelessChangeUserFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
    },

    fetchChangeUserOptions: () => (dispatch) => {
        fetchPurposeList(dispatch, "", true);
    }
    , onSubscriptionSelect: (value, propsName, objects, index) => async (dispatch, state) => {
        const { wirelessChangeUserFormA } = state().form;
        const { takeActionCircuitId } = state().createRequest;

        if (value === '' || !propsName) {
            fetchPurposeList(dispatch, '', false);
            dispatch(actions.reset('wirelessChangeUserFormA'));            
            dispatch({ type: setSubscriptionDetails, data: {} });
            dispatch({ type: setNewUserDetails, data: {} });
        } else {
            if(propsName) {
                var obj=null              
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    } 
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value & o['CircuitId'] === takeActionCircuitId);
                    } 
                }
                if (obj != null && obj.CircuitId != wirelessChangeUserFormA.circuitId) {
                    dispatch(actions.reset('wirelessChangeUserFormA'));
                    dispatch(actions.change('wirelessChangeUserFormA.circuitCode', value));
                    dispatch(actions.change('wirelessChangeUserFormA.circuitId', obj.CircuitId));
                    dispatch(actions.change('wirelessChangeUserFormA.employeeId', 0));
                    dispatch({ type: setSubscriptionDetails, data: obj });
                    
                    fetchPurposeList(dispatch, obj.CircuitCode, false);
                }
            }
        }
       
    }
    , onEmployeeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelessChangeUserFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelessChangeUserFormA.employeeEmail', ''));
            dispatch(actions.change('wirelessChangeUserFormA.employeeId', 0));
            dispatch({ type: setNewUserDetails, data: {} });
        } else {
            if(propsName) {
                var obj = objects.find(o => o[propsName] === value);
                if (obj != null && obj.EmployeeId != wirelessChangeUserFormA.employeeId) {
                    dispatch(requestDetailsActions.fetchWorkFlowApproverDetails(obj.EmployeeId, true));
                    dispatch(actions.change('wirelessChangeUserFormA.employeeEmail', obj.LastFirstName));
                    dispatch(actions.change('wirelessChangeUserFormA.employeeId', obj.EmployeeId));
                    dispatch({ type: setNewUserDetails, data: obj });
                }
            }            
        }
    }
    , submitRequest: () => async (dispatch, state) => {

        const { wirelessChangeUserFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest, subscriptionList } = state().createRequest;
        const { subscription, newUser } = state().wirelessChangeUserRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }
        let changeRequestData = {
            ...userData
            , ...wirelessChangeUserFormA
           
        }

        if (isUpdateRequest) {
            const { requestData } = state().requestDetail;
            const { wirelessChangeUserFormA } = state().form;



            changeRequestData = {
                ...changeRequestData
                , ...wirelessChangeUserFormA
                , OrderId: requestData.Order.OrderId
                , OrderInfoId: requestData.OrderInfoId
                , CircuitOrderId: requestData.CircuitOrderId
                , OrderHistoryId: requestData.OrderHistoryId
                , CircuitCode: wirelessChangeUserFormA.circuitCode
                , CircuitId: wirelessChangeUserFormA.circuitCode ? wirelessChangeUserFormA.circuitId : 0



            }
        }
        userData.employeeID = newUser.EmployeeId;
        userData.managerApproverId = newUser.CostCodeApprover;

        var data = {
            ChangeRequestModel: {
                ...userData
                , ... changeRequestData
                , CircuitId: subscriptionList.length != 0 ? subscriptionList[0].CircuitId : subscription.CircuitId
                , VendorDetailId: subscriptionList.length != 0 ? subscriptionList[0].VendorDetailId : subscription.VendorDetailId
                , PurposeId: wirelessChangeUserFormA.purposeOfUseId
                , BusinessJustification: wirelessChangeUserFormA.businessJustification
                , BusinessJustificationModel: { ...wirelessChangeUserFormA }
                , BusinessCaseId: wirelessChangeUserFormA.busJustiCodeDetailId
                , AdditionalInformation: wirelessChangeUserFormA.additionalInformation
                , RequestTypeId: requestTypeId
                , NoEmail: false
                , RequestorID: Number(changeRequestData.employeeID)
            },
            IsAmending: isUpdateRequest,
            NewUserId: wirelessChangeUserFormA.employeeId
        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/changeUser/submitChangeUser', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }



    , resetWirelessChangeUserForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {
        
        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }

        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessChangeUserFormA.circuitCode'));
            dispatch(actions.reset('wirelessChangeUserFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessChangeUserFormA'));
            dispatch({ type: setNewUserDetails, data: defaultState.newUser });
        }
        
        dispatch(actions.reset('wirelessChangeUserFormA.employeeEmail'));
        dispatch(actions.reset('wirelessChangeUserFormA.employeeId'));
        dispatch(actions.reset('wirelessChangeUserFormA'));
        dispatch({ type: setNewUserDetails, data: {} });
        dispatch({ type: setFormSubmitted, data: false });
    }
}

function newUserRequestList(val, canSearchSelf, isRequestOnBehalf, state) {

    const { requestTypeId, requestOnBehalfData } = state()?.createRequest;

    var empIdRob = requestOnBehalfData.EmployeeId

    return 'external/autosuggest/getEmployees/'
        + sessionStorage.EmployeeID + '/'
        + sessionStorage.UserRoleID + '/'
        + sessionStorage.IsExecutive + '/'
        + sessionStorage.IsKeyUser + '/'
        + val + '/'
        + isRequestOnBehalf + '/'
        + requestTypeId + '/'
        + empIdRob + '/'
        + canSearchSelf
}

async function getEmployeeDetails(dispatch, state, val) {
    const { wirelessChangeUserFormA } = state().form;

    var propsName = 'LastFirstName'

    var empList = await httpGet(newUserRequestList(val, true, true, state));

    var obj = empList.find(o => o[propsName] === val);
    if (obj != null && obj.EmployeeId != wirelessChangeUserFormA.employeeId) {
        dispatch(actions.change('wirelessChangeUserFormA.employeeEmail', val));
        dispatch(actions.change('wirelessChangeUserFormA.employeeId', obj.EmployeeId));
        dispatch({ type: setNewUserDetails, data: obj });
    }
}
async function fetchPurposeList(dispatch) {

    var data = {
        EmployeeId: getUserData().employeeID,
        IsKeyUser: "false"
    }

    var res = await httpPost('external/changeUser/getPurpose', data);

    if (res) {
        dispatch({ type: setPurposeOptions, data: res });
    } else {
        dispatch({ type: setPurposeOptions, data: [] });
    }

}
async function fetchBusinessCaseList(dispatch) {

    var data = {
        EmployeeId: getUserData().employeeID,
        IsKeyUser: "false"
    }

    var res = await httpPost('external/replaceDevice/getBusinessCases', data);

    if (res) {
        dispatch({ type: setBusinessCaseOptions, data: res });
    } else {
        dispatch({ type: setBusinessCaseOptions, data: [] });
    }

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setNewUserDetails:
            return {
                ...state
                , newUser: { ...action.data }
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setPurposeOptions:
            return {
                ...state
                , purposeOptions: action.data
            };
        case setBusinessCaseOptions:
            return {
                ...state
                , businessCaseOptions: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setFormLoading:
            return {
                ...state
                , isFormLoading: action.data
            }
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            }
        default: return state;
    }
}